import { render, staticRenderFns } from "./damage-assessment.vue?vue&type=template&id=08db090e&scoped=true"
import script from "./damage-assessment.vue?vue&type=script&lang=js"
export * from "./damage-assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db090e",
  null
  
)

export default component.exports